// extracted by mini-css-extract-plugin
module.exports = {"icon":"Close_icon__VWWIe"};